<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Internal Budget Addition Form
                <div class="card-header-actions">
                <b-button variant="primary" v-if="saveEnabled" @click="save()"><i class="fa fa-save"></i> Save</b-button>
                <b-button variant="secondary" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col md="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Internal Budget No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomorintern" readonly :state="!$v.model.ibudghdkey.$error"></b-form-input>
                                <b-input-group-append v-if="saveEnabled">
                                <b-btn text="Button" @click="lkuBudgetShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col md="4">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Create Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.ibtanggal" type="date"  disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row >  
                            <b-input-group >
                                <b-input-group-prepend><label>Budget Name</label></b-input-group-prepend>
                                <b-form-input v-model="model.uraian"  readonly></b-form-input>
                                <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.sales" disabled class="ml-1 mt-1">Budget Sales</b-form-checkbox>
                            </b-input-group>
                    <!-- <b-row>
                        <b-col md="9">
                        </b-col>
                        <b-col md="3">
                            <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.sales" disabled class="mt-1">Budget Sales</b-form-checkbox>
                        </b-col>
                    </b-row>     -->
                    <b-row>
                        <b-col md="6">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Nomor Produksi.</label></b-input-group-prepend>
                                <b-form-input v-model="model.noprodintern" readonly placeholder="comma separated" ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="6">
                            <b-input-group >
                                    <b-input-group-prepend><label >Tanggal Produksi</label></b-input-group-prepend>
                                    <b-form-input v-model="model.requstart" type="date" disabled></b-form-input>
                                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                                    <b-form-input v-model="model.requend" type="date" disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row v-if="(model.sales=='1')">
                        <b-col md="7">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.custinfo" ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer Order No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.cust_po" placeholder="Customer Order No." readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    

                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr"></v-dim>
                </b-col>
              </b-row>
            <hr>
              <b-row>
                <b-col lg="8">
                    <b-row align-h="between">
                        <b-col md="4">
                            <b-input-group>
                                <b-input-group-prepend><label>Additional Budget#</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomoradd" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="4">
                            <b-input-group>
                                <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.addtanggal" type="date" :state="!$v.model.addtanggal.$error"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-input-group>
                        <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                        <b-form-input v-model="model.remark" :state="!$v.model.remark.$error"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>

            <div class="report-wraper" >
                <table style="width: 100%;" v-show="(showFormDetail == false)">
                    <thead>
                        <tr>
                            <th style="max-width:13px;text-align:center;padding:0;" rowspan="2">No.</th>
                            <th colspan="7" style="text-align:center">INTERNAL BUDGET</th>
                            <th style="text-align:center;max-width:100px;">REQUESTED</th>
                            <th colspan="2" style="text-align:center">ADDITIONAL BUDGET</th>
                        </tr>
                        <tr>
                            <th style="min-width:300px">Description</th>
                            <th style="text-align:center; max-width:60px;padding:0;">Unit</th>
                            <th style="text-align:center; max-width:60px;padding:0;">QTY</th>
                            <th style="text-align:center; max-width:60px;padding:0;">Repe-tition</th>
                            <th style="text-align:right" width="100px">Unit Price</th>
                            <th style="text-align:right" width="120px">Amount </th>
                            <th style="min-width:120px">Remark</th>
                            <th style="text-align:center;max-width:120px;">(IN USED)</th>
                            <th style="text-align:right;max-width:120px;">Amount </th>
                            <th style="text-align:center;max-width:120px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, idx) in budgetLines" :key="row.pjxbudgkey">
                            <td style="max-width:20px; padding-left:2px; padding-right:0;">{{idx+1}}</td>
                            <td>{{row.jccostname}} &nbsp; &nbsp; {{row.uraian}}</td>
                            <td style="text-align:center; max-width:60px;padding:0;">{{row.unitsize}}</td>
                            <td style="text-align:center; max-width:60px;padding:0;">{{row.ibquantity}}</td>
                            <td style="text-align:center; max-width:60px;padding:0;">{{row.ibrepetit_qty}} {{row.repetit_nm}}</td>
                            <td style="text-align:right">{{row.unitprice |numFormat}}</td>
                            <td style="text-align:right">{{row.ibbudgetamt |numFormat}}</td>
                            <td>{{row.remark}}</td>
                            <td style="text-align:right">{{row.toalreq |numFormat}}</td>
                            <td style="text-align:right">
                                <my-number v-if="(saveEnabled==true)" v-model="row.addbudgetamt"  @change="calcTotalDtlBudget()" :minus="true"  class="form-control text-right"  style="border:none; font-size: 0.8rem !important;" :precision="2"></my-number>
                                <span v-else>{{row.addbudgetamt |numFormat}}</span>
                            </td>
                            <td >
                                <div class="text-center" v-if="!(row.pjxbudgkey)">
                                <a href="javascript:void(0)" class="text-danger" @click="delOrdLines(idx)">
                                    <i class="fa fa-trash"></i>
                                </a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="subtotal"></td>
                            <td class="subtotal">                         
                            </td>
                            <td class="subtotal" colspan="4" style="text-align:right">Total Internal Budget</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlmstr|numFormat}}</td>
                            <td class="subtotal" style="text-align:right"> Budget Used</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlused|numFormat}}</td>
                            <td class="subtotal"  style="text-align:right">Total Additional Budget</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttladd|numFormat}}</td>
                        </tr>
                    </tbody>
                </table>           

            </div>                  

            <b-row class="justify-content-center mt-2" v-show="(showFormDetail == false)">
                <b-button variant="primary" v-if="saveEnabled" @click="save()"><i class="fa fa-save"></i> Save</b-button>
                <b-button variant="secondary" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </b-card>
        <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget" :centered="true">
            <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
        </b-modal>        

    </div>
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }

            td.grdtotal {
                border-top: 2px solid #000 !important;
                border-bottom: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 90px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dimReadonly";
import lkuBudgetinternal from "../lookup/lkuBudgetinternal";
import budgetaddinternal from "../../apis/budgetaddinternal";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim, lkuBudgetinternal},
  mixins: [validationMixin],
  validations: {
        model: {
            ibudghdkey: {required},
            pjxhdrkey: {required},
            remark: { required },
            addtanggal: { required }
        },
        ordLinesObj: {
            jccostkey: { required },
            addquantity: { numeric, required },
            unitprice: { numeric, required },
            addbudgetamt: { numeric, required },
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        lkuItemShow:false,
        lkuBudgetShow:false,
        updateDimHdr:false,
        uanguser: this.$store.state.user.matauang,
        budgetLines:[],
        model: {
            ibudghdkey: '',
            pjxhdrkey: '',
            remark: '',
            addtanggal: ''
        },
        ordLinesObj: {
            jccostkey: '',
            addquantity: '',
            unitprice: '',
            addbudgetamt: '',
        },
        showFormDetail:false,
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidOrdLines() {
      this.$v.ordLinesObj.$touch();
      return this.$v.ordLinesObj.$invalid;
    },
    unitprice(){
        return this.ordLinesObj.unitprice;
    },    
  },
  watch: {
    unitprice: function(newval) {
        setTimeout(() => {
            this.calcPrice();
        }, 100);
    },    
  },  
  created: async function(){
        this.routeAsal = localStorage.getItem('ibadd-menu') || "budget.internbudgetadd";
        if (this.$route.params.addhdkey)  {
          toastr.info('Loading Budget Detail, please wait')
          try {
            const data = await budgetaddinternal.detail(this.$route.params);  
            const row = data[0];
            this.saveEnabled = (row.send2wf == 1 && row.isreviewed != 1) ? false : true;
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.ibtanggal = row.ibtanggal ? moment(row.ibtanggal).format('YYYY-MM-DD') : '';
            row.startdate = row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : '';
            row.finishdate = row.finishdate ? moment(row.finishdate).format('YYYY-MM-DD') : '';
            row.addtanggal = row.addtanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';

            row.requstart = row.requstart ? moment(row.requstart).format('YYYY-MM-DD') : '';
            row.requend = row.requend ? moment(row.requend).format('YYYY-MM-DD') : '';

            for (var key in row) {
                this.model[key] = row[key];
            }
            this.dimension.forEach((dim) => {
                if (this.model[dim.value]) {
                    this.model[`${dim.value}Info`] = this.model[dim.value] + ' | '+ this.model[`${dim.value}Txt`];
                }
            });
            
            this.budgetLines = data[1];
            // this.budgetLines.forEach((line,idx) => {
            //     this.budgetLines[idx].budgetrata2= line.budgetamt/this.model.jmlproduksi;
            // });
            this.calcTotalDtlBudget();
            toastr.clear;
            this.updateDimHdr = !this.updateDimHdr;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.addtanggal  = moment().format('YYYY-MM-DD');
        }
  },
  methods: {

    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;
        if (this.invalidModel) {
            const invalidobj = {};
            for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError == true) invalidobj[key] = this.$v.model[key];
            }
            }
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;
        } else {
            try {
                    // this.model.addhdkey = this.model.pjxbudgkey || '';
                    // this.model.nomoradd = this.model.nomoradd || '';
                    const row = {};
                    row.addhdkey = this.model.pjxbudgkey || '';
                    row.nomoradd = this.model.nomoradd || '';
                    row.addtanggal= this.model.addtanggal ? moment(this.model.addtanggal).format('YYYY-MM-DD') : undefined;
                    row.pjxhdrkey = this.model.pjxhdrkey || '';
                    row.ibudghdkey = this.model.ibudghdkey || '';
                    row.nomor = this.model.nomor || '';
                    row.remark = this.model.remark || '';
                    let seqNo = 1;
                    row.lines=[];
                    this.budgetLines.forEach((item,idx) => {
                        seqNo += 1;
                        // if (((item.addquantity) && (item.addquantity!=0)) || ((item.addrepetit_qty) && (item.addrepetit_qty!=0))) {
                        if (item.addbudgetamt) {
                            this.budgetLines[idx].seqNo = seqNo;
                            row.lines.push(item);       
                        }
                    });
                    if (row.lines.length>0) {
                        // await budgetaddinternal.save(row);
                        // toastr.success("Complete successfully", "Save Budget");
                        const hasil= await budgetaddinternal.save(row);
                        toastr.success(`Success, Trx.Number ${hasil.nomoradd}`, "Save Budget",10000);

                        this.close();
                    } else {
                        toastr.error('Please fill at least 1(one) Budget Detail', 'ERROR MESSAGE');
                        this.saveEnabled=true;
                    }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }

        }
    },
    onSelectLkuBudget: async function (_selected) {
        try {
            this.lkuBudgetShow=false;
            toastr.info("Loading Budget Details");                              
            const data = await budgetaddinternal.internbudget({ibudghdkey:_selected.ibudghdkey});  
            const row = data[1][0];
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.ibtanggal = row.ibtanggal ? moment(row.ibtanggal).format('YYYY-MM-DD') : '';
            row.startdate = row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : '';
            row.finishdate = row.finishdate ? moment(row.finishdate).format('YYYY-MM-DD') : '';
            row.requstart = row.requstart ? moment(row.requstart).format('YYYY-MM-DD') : '';
            row.requend = row.requend ? moment(row.requend).format('YYYY-MM-DD') : '';


            for (var key in row) {
                this.model[key] = row[key];
            }
            this.dimension.forEach((dim) => {
                if (row[dim.value]) {
                    this.model[`${dim.value}Info`] = row[dim.value] + ' | '+ row[`${dim.value}Txt`];
                }
                if (dim.RelatedObj=='internalbudget') {
                    this.model[`${dim.value}`] = _selected.nomorintern;
                    this.model[`${dim.value}Txt`] = _selected.uraian + ' # '+ _selected.noprodintern;
                    this.model[`${dim.value}Info`] = _selected.nomorintern + ' | '+ _selected.uraian + ' # '+ _selected.noprodintern;
                }
            });
            this.updateDimHdr=!this.updateDimHdr;
            this.budgetLines = data[0];
            // this.budgetLines.forEach((line,idx) => {
            //     this.budgetLines[idx].budgetrata2=line.budgetamt/this.model.jmlproduksi;
            //     this.budgetLines[idx].addquantity=0;
            //     this.budgetLines[idx].addrepetit_qty='';
            // });

            this.calcTotalDtlBudget();
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    },
    calcAmount : function (budgetLine) {
        budgetLine.addbudgetamt = parseFloat(budgetLine.addquantity) * parseFloat(budgetLine.unitprice) * parseFloat(budgetLine.addrepetit_qty || 1);
        this.calcTotalDtlBudget();
        this.$forceUpdate();
    },
    calcPrice : function () {
        this.ordLinesObj.addbudgetamt = parseFloat(this.ordLinesObj.addquantity) * parseFloat(this.ordLinesObj.unitprice) * parseFloat(this.ordLinesObj.addrepetit_qty || 1);
    },
    calcTotalDtlBudget: function () {
        let ttlamtdue = 0;
        let ttlamtadd = 0;
        let ttlamtused = 0;
        this.budgetLines.forEach((trx)=> {
                ttlamtdue += (trx.ibbudgetamt || 0);
                ttlamtadd += (trx.addbudgetamt || 0);
                ttlamtused += (trx.totalreq || 0);
        });
        this.model.ttlmstr = ttlamtdue;
        this.model.ttladd = ttlamtadd;
        this.model.ttlused = ttlamtused;
    },
    close(){
      if (this.routeAsal) {
          router.push({name:this.routeAsal});    
      } else {
          router.push({path:"home"});    
      }
    }
  }
};
</script>
